import {
  deepCopy,
  genericXHRErrorHandler,
  getAuthHeader,
  globalNeedToSetTheScale,
  printTimeTaken,
  toastInfo,
  toastInfoSingle
} from "src/components/Planner/controller";
import {ts} from "src/utils/translate";
import {
  ModifyOuterWallsAction
} from "src/components/Planner/planner/history/outerwall-actions";
import * as d3 from "d3";
import $ from "jquery";
import {
  arrayIntersection,
  getWallById,
  uMath,
  XYtoNumPoly
} from "src/components/Planner/planner/uMath";
import {getInnerRooms, uDev} from "src/components/Planner/planner/uDev";
import {uDevDOM} from "src/components/Planner/planner/uDev-dom";
import {wallModHelper} from "src/components/Planner/planner/wallModHelper";
import {
  showDragAndDropOverlay
} from "src/components/Planner/planner/draganddrop";
import {ROOT_URI} from "src/utils/constants";
import {redrawDevices} from "src/components/Planner/planner/deviceDrawing";
import {
  addContainerForHullTest,
  AnyLineIntersectsARoomMod,
  AnyLineIntersectsSelfMod,
  calculateWallMidpoints,
  CMToPx,
  redrawRooms,
  selectRoom,
  setIsTheScaleChecked,
  setMode
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {WIFICALC} from "src/components/Planner/planner/wificalc";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";

export function drawOuterWallModifyCircles() {
  PlannerGlobals.container.select(".modifyCircles").remove();
  var circlesGroup = PlannerGlobals.container.append('g').attr('class', 'modifyCircles');

  circlesGroup.selectAll('circle.modifyCircle').data(PlannerGlobals.modifiedOuterWalls).enter()
  .append('circle')
  .attr('class', 'modifyCircle')
  .attr('cx', function (d) {
    return +d.x;
  })
  .attr('cy', function (d) {
    return +d.y;
  })
  .attr('r', (PlannerGlobals.DRAW_CIRCLE_R * 2) / PlannerGlobals.scalevar)
  .attr('fill', '#fff')
  .attr('stroke', '#000')
  .attr('stroke-width', PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar)
  .style('cursor', 'default')
  .call(PlannerGlobals.dragOuterWallCircle);

  var midpoints = calculateWallMidpoints(PlannerGlobals.modifiedOuterWalls);

  circlesGroup.selectAll('circle.modifyMidpointCircle').data(midpoints).enter()
  .append('circle')
  .attr('class', 'modifyMidpointCircle')
  .attr('cx', function (d) { return d.x; })
  .attr('cy', function (d) { return d.y; })
  .attr('r', (PlannerGlobals.DRAW_CIRCLE_R * 1.4) / PlannerGlobals.scalevar)
  .attr('fill', '#e0e0e0')
  .attr('stroke', '#666')
  .attr('stroke-width', PlannerGlobals.DRAW_CIRCLE_STROKE_WIDTH / PlannerGlobals.scalevar)
  .style('cursor', 'pointer')
  .call(PlannerGlobals.dragOuterWallCircle);
}

export function drawOuterWallModifyPolyline() {
  var selectPoints = PlannerGlobals.modifiedOuterWalls.map(function (currXY) {
    return [+currXY.x, +currXY.y];
  });

  selectPoints.push(selectPoints[0]);
  d3.select('.selectPolyline').remove();
  PlannerGlobals.container.insert('polyline', '.modifyCircles')
  .attr('class', 'selectPolyline')
  .attr('points', selectPoints)
  .style('fill', 'none')
  .attr('stroke', 'orange')
  .attr('stroke-width', PlannerGlobals.MODIFY_POLYLINE_STROKE / PlannerGlobals.scalevar);
}

export function drawOuterWallModify() {
  if (uDev.outerBorderExists()) {
    PlannerGlobals.modifiedOuterWalls = $.extend(true, [],
        PlannerGlobals.outerBorder);

    drawOuterWallModifyCircles();
    drawOuterWallModifyPolyline();
  } else {
    setMode.basic();
  }
}

export function selectOuterWalls() {
  var fakeRoom = {
    id: -2,
    poly: JSON.parse(JSON.stringify(PlannerGlobals.outerBorder))
  }
  PlannerGlobals.rooms.push(fakeRoom);
  selectRoom(-2);
}

export function modifyOuterWallSave() {
  if (PlannerGlobals.modifying) {

    var preventMod = false;
    try {
      var testRes;
      if (AnyLineIntersectsSelfMod()) {
        toastInfo(
            ts('p_ow_intersect_s_err', "Walls can't intersect themselves."));
        preventMod = true;
      } else if (testRes = AnyLineIntersectsARoomMod(), testRes) {
        toastInfo(ts('p_ow_intersect_o_err', "Walls can't intersect rooms."));
        preventMod = true;
      }
    } catch (err) {
      console.log(err);
    }

    if (preventMod) {
      return;
    }

    var outerBorderCpy = deepCopy(PlannerGlobals.outerBorder);
    var modifiedPolyCpy = deepCopy(PlannerGlobals.modifiedPoly);
    saveOuterWalls(PlannerGlobals.modifiedPoly,
        function (d3Devs, groups, serConns) {
          var action = new ModifyOuterWallsAction(outerBorderCpy,
              modifiedPolyCpy, d3Devs, groups,
              PlannerGlobals.selectRoomBeginMatSaveState, serConns);
          PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
          PlannerGlobals.wallSegmentation.recalcPreserveSave(
              PlannerGlobals.selectRoomBeginMatSaveState);
        });
    setMode.basic();
  }
}

export function redrawOuterWalls() {
  d3.select('#outerBorderLine').remove();

  PlannerGlobals.container.insert('polygon', '.rooms')
    .attr('id', 'outerBorderLine')
    .attr('points', PlannerGlobals.outerBorder.map(function (d) {
      return [d.x, d.y].join(',');
    }).join(" "))
    .attr('stroke', "orange")
    .attr('stroke-width', 0.5)
    .attr('fill', 'white')
    .attr('fill-opacity', 0)
    .attr('style', 'pointer-events: none;');

}

export function instantCalcOuter(callback, failCallback) {
  if (PlannerGlobals.isInQuote) {
    return;
  }
  if (PlannerGlobals.lastCalculatedOuterWall && uDev.outerBorderExists()) {
    if (typeof callback === "function") {
      callback(PlannerGlobals.lastCalculatedOuterWall);
    }
  } else {
    PlannerGlobals.calcOuterPromise = $.Deferred();
    PlannerGlobals.calcOuterPromise.done(function () {
      if (typeof callback === "function") {
        callback(PlannerGlobals.lastCalculatedOuterWall);
      }
    });
    if (typeof failCallback === "function") {
      PlannerGlobals.calcOuterPromise.fail(failCallback);
    }
    if (PlannerGlobals.lastCalculatedOuterWallTimeout) {
      clearTimeout(PlannerGlobals.lastCalculatedOuterWallTimeout);
      PlannerGlobals.lastCalculatedOuterWallTimeout = null;
    }
    calcOuter(PlannerGlobals.rooms);
  }
}

export function willCalcOuter() {
  WIFICALC.reset();

  if (PlannerGlobals.isInQuote) {
    return;
  }
  var propRooms = $.extend(true, [], PlannerGlobals.rooms);
  if (PlannerGlobals.lastCalculatedOuterWallTimeout) {
    clearTimeout(PlannerGlobals.lastCalculatedOuterWallTimeout);
    PlannerGlobals.lastCalculatedOuterWallTimeout = null;
  }
  PlannerGlobals.lastCalculatedOuterWallTimeout = setTimeout(function () {
    calcOuter(propRooms);
  }, 5000);
}

export function deleteOuterWalls(callback, errorCallback) {
  getAuthHeader(function (headers) {
    $.ajax({
      headers,
      method: 'POST',
      url: ROOT_URI + '/floor/outer-wall-polies',
      data: {
        floor_id: PlannerGlobals.plannerFloorId,
        outer_wall_polygons: JSON.stringify([])
      },
      success: function () {
        PlannerGlobals.outerBorder = [];
        redrawOuterWalls();
        willCalcOuter();
        uDevDOM.makeOutdoorDevsUnassigned()
        .then((resp) => (typeof callback === "function") && callback(resp))
        .catch((resp) => (typeof errorCallback === "function") && errorCallback(
            resp))
        .finally(() => refreshFloorView());
      },
      error: function (resp) {
        if (errorCallback) {
          errorCallback();
        }
        genericXHRErrorHandler(resp);
      }
    });
  });
}

export function saveOuterWalls(newOuterWalls, callback, errorCallback) {
  var walls = newOuterWalls.map(function (wall, idx) {
    if (('x' in wall) && ('y' in wall)) {
      return {
        x: wall.x,
        y: wall.y,
        order_index: idx
      };
    } else if (Array.isArray(wall)) {
      return {
        x: wall[0],
        y: wall[1],
        order_index: idx
      };
    } else {
      console.log(wall);
      throw new Error(wall);
    }
  });
  var existing = Object.assign([], PlannerGlobals.outerBorder);
  PlannerGlobals.outerBorder = JSON.parse(JSON.stringify(walls));
  redrawOuterWalls();
  getAuthHeader(function (headers) {
    $.ajax({
      headers,
      url: ROOT_URI + '/floor/outer-wall-polies',
      method: 'POST',
      data: {
        floor_id: PlannerGlobals.plannerFloorId,
        outer_wall_polygons: JSON.stringify(PlannerGlobals.outerBorder)
      },
      success: function () {
        uDevDOM.refreshDevRoomsForOuterBorderModify(callback);
        redrawRooms();
        redrawDevices();
        instantCalcOuter();
        // newTour.triggerEvent({ done: 'draw_outer_wall' });
      },
      error: function (resp) {
        genericXHRErrorHandler(resp);
        PlannerGlobals.outerBorder = Object.assign([], existing);
        redrawOuterWalls();
        if (errorCallback) {
          errorCallback();
        }
      }
    });
  });
}

export function outerWallModCleanup() {
  if (PlannerGlobals.mode == 'modifyOuterW') {
    PlannerGlobals.modifying = false;
    PlannerGlobals.svg.selectAll('.modifyCircles').remove();
    PlannerGlobals.svg.selectAll('.selectPolyline').remove();
    $(".planner-buttons-cont").not('.planner-modify-item').not(
        '#planner-buttons-crop').removeClass('hidden');
    redrawOuterWalls();
  }
}

export function drawOuterWalls(wallIds) {
  var segments = wallIds.map(getWallById);

  var u2 = d3.select('#hullTestGL')
  .selectAll('line')
  .data(segments);
  u2.enter()
  .append('line');
  u2.attr('x1', function (d) { return d.x1 })
    .attr('y1', function (d) { return d.y1 })
    .attr('x2', function (d) { return d.x2 })
    .attr('y2', function (d) { return d.y2 })
    .attr('stroke', 'red')
    .attr('stroke-width', 1.3)
    .attr('style', 'opacity: 0.8;');
  u2.exit().remove();
}

/**
 * @param {number} cm
 */
export function calcOuter(propRooms = null, cm = 35, wallGranularity = 0.7,
    debug = false) {

  // The debounced willCalcOuter timeout can fire after the planner has unmounted
  // (e.g. the floor query is refetching after recognition); skip if the canvas is gone.
  if (!document.getElementById('planner-overlay')) {
    return;
  }

  if (globalNeedToSetTheScale) {
    PlannerGlobals.wallSelectStartPos = [100, 100];
    PlannerGlobals.wallSelectEndPos = [200, 100];
  }

  if (PlannerGlobals.mode == 'wallSelect' && PlannerGlobals.rooms.length == 0) {
    return;
  } else if (!PlannerGlobals.LENGTHOF1PX || !PlannerGlobals.lastRatioPoints) {

    if (globalNeedToSetTheScale) {
      PlannerGlobals.LENGTHOF1PX = 2.403;
      globalNeedToSetTheScale = false;
      $("#toggle-wallselect-btn").click()
    }

    toastInfo((ts('p_can_now_mark', "Mark the scale of the floor plan!")));
    return;
  } else if (globalNeedToSetTheScale) {
    globalNeedToSetTheScale = false;
    $("#toggle-wallselect-btn").click()
    toastInfo((ts('p_can_now_mark', "Mark the scale of the floor plan!")));
    return;
  } else if (!PlannerGlobals.isScaleChecked) {
    globalNeedToSetTheScale = false;
    toastInfo(
        (ts('p_check_the_scale', "Check the scale in the floor's settings!")));
    setIsTheScaleChecked(PlannerGlobals.plannerFloorId)
    PlannerGlobals.sScaleChecked = 1;

    return;
  } else if (!uDev.outerBorderExists()) {
    if (globalNeedToSetTheScale) {
      globalNeedToSetTheScale = false;
      $("#toggle-wallselect-btn").click()
      toastInfo((ts('p_can_now_mark', "Mark the scale of the floor plan!")));
      return;
    } else {
      if (PlannerGlobals.calcOuterPromise) {
        PlannerGlobals.calcOuterPromise.reject();
      }
      // if (!newTour.isOngoing()) {
      if (!$('#planner-overlay').is(':visible')) {
        toastInfo(ts('p_ow_markouter',
            "Please draw the outer walls to enable additional calculations! <b>Hotkey: 4</b>").replace(
            '6', '1'));
      }
      // }

      showDragAndDropOverlay();

      return;
    }

  } else if (PlannerGlobals.rooms.length == 0) {
    if (PlannerGlobals.calcOuterPromise) {
      PlannerGlobals.calcOuterPromise.reject();
    }
    // if (!newTour.isOngoing()) {
    toastInfo(ts('p_tut_select_draw',
        'To start drawing rooms, click on the "Draw" tool, or press its <b>hotkey (1)</b>.').replace(
        '1', '2'));
    // }
    showDragAndDropOverlay();
    return;
  } else if (!PlannerGlobals.LENGTHOF1PX) {
    if (PlannerGlobals.calcOuterPromise) {
      PlannerGlobals.calcOuterPromise.reject();
    }
    return toastInfoSingle(ts('p_can_now_mark', 'p_canNowMark'));
  }

  showDragAndDropOverlay();

  if (!propRooms) {
    propRooms = PlannerGlobals.rooms;
  }
  var concavity = uMath.clamp(CMToPx(cm), 10, Infinity);
  addContainerForHullTest();
  if (!PlannerGlobals.OUTERWALL_WORKER) {
    PlannerGlobals.OUTERWALL_WORKER = new Worker(new URL('./outerwall-worker.js', import.meta.url));
    PlannerGlobals.OUTERWALL_WORKER.onmessage = function (e) {
      try {
        if (e.data.result && e.data.result.wallIds && e.data.result.outerHull && e.data.floorId == PlannerGlobals.plannerFloorId) {
          var wallIds = e.data.result.wallIds;
          var outerHull = e.data.result.outerHull;
          var wallPaths = e.data.result.wallPaths;
          if (e.data.debug) {
            performance.mark('calcEnd');
            try {
              performance.measure('calc', 'calcStart', 'calcEnd');
              printTimeTaken('calc');
            }
            catch (e) {
              console.log(e);
            }
            performance.clearMeasures();
            performance.clearMarks();
          }
          // red lines
          if (wallIds.length > 0) {
            if (e.data.debug) {
              drawOuterWalls(wallIds);
            }
            PlannerGlobals.outerWallIds = wallIds;
          }
          if (outerHull.length > 0) {
            if (e.data.debug) {
              var u = d3.select('#hullTestGC')
              .selectAll('circle')
              .data(outerHull);
              u.enter()
              .append('circle');
              u.attr('cx', function (d) { return d[0]; })
                .attr('cy', function (d) { return d[1]; })
                .attr('style', 'fill: red; fill-opacity: 0.8;')
                .attr('stroke', 'black')
                .attr('r', 1.3 / 2)
                .attr('stroke-width', 0.3);
              u.exit().remove();
            }

            var hullPoly = outerHull.map(function (point) {
              return [point[0], point[1]];
            });

            var hullArea = Math.abs(d3.polygonArea(hullPoly));

            var outerWallPoly = XYtoNumPoly(PlannerGlobals.outerBorder);
            var outerWallArea = Math.abs(d3.polygonArea(outerWallPoly));
            var outerWallPerimeter = d3.polygonLength(outerWallPoly);

            var hullMPoly = [hullPoly];
            var outerWallMPoly = [outerWallPoly];

            var diff = uMath.polygonClipping.difference(outerWallMPoly, hullMPoly);

            /**
             * @type {WallMod[]}
             */
            var outerWallMods = [];
            wallPaths.forEach(function (path) {
              var wallIds = path.pathWallIds;
              var res = wallModHelper.getWallModsOfWall(wallIds);
              if (res.length > 0) {
                outerWallMods = outerWallMods.concat(res);
              }
            });

            var windowDoorArea = 0;

            outerWallMods.forEach(function (wallMod) {
              var pt0 = uMath.pointClosestPtToPolygon(wallMod.points[0], PlannerGlobals.outerBorder);
              var pt1 = uMath.pointClosestPtToPolygon(wallMod.points[1], PlannerGlobals.outerBorder);

              if (uMath.areSegmentsPerpendicular(pt0.segment, uMath.segmentFromPoints(pt0, wallMod.points[0])) &&
                  uMath.areSegmentsPerpendicular(pt1.segment, uMath.segmentFromPoints(pt1, wallMod.points[1]))) {
                var dist = uMath.pointDistance(pt0, pt1);
                outerWallPerimeter -= dist;
                var poly = XYtoNumPoly([wallMod.points[0], wallMod.points[1], pt1, pt0]);
                windowDoorArea += Math.abs(d3.polygonArea(poly));
                diff = uMath.polygonClipping.difference(diff, [poly]);
              }
            });

            if (e.data.debug) {
              PlannerGlobals.svg.selectAll('.diffPrevPoly').remove();
              diff.forEach(function (poly) {
                PlannerGlobals.container.insert('polygon', '#hullTestGL')
                  .attr('points', poly.map(function (pt) { return pt.join(" ") }).join(" "))
                  .attr('style', "fill: orange; fill-opacity: 0.8;")
                  .attr('class', 'diffPrevPoly');
              });
            }

            var roomAllArea = 0;

            var innerRooms = getInnerRooms(PlannerGlobals.rooms, PlannerGlobals.outerBorder);
            var innerRoomIds = innerRooms.map(function (room) { return room.id; });
            var roomsMPoly = innerRooms.map(function (room) {
              var poly = XYtoNumPoly(room.poly);
              roomAllArea += Math.abs(d3.polygonArea(poly));
              if (uMath.isRoomClockwise(room)) {
                poly.reverse();
              }
              return [poly];
            });

            var innerDiff = null;
            if (e.data.debug) {
              innerDiff = uMath.polygonClipping.difference(hullMPoly, roomsMPoly);
            }

            var innerDoorArea = 0;
            PlannerGlobals.wallModConnections
            .filter(function (wallModConn) {
              return wallModConn.rooms.length == 2 && arrayIntersection(wallModConn.rooms.map(function (wallMod) { return wallMod.roomId; }), innerRoomIds).length == 2;
            })
            .forEach(function (wallModConn) {
              try {
                var ptpairs = wallModHelper.wallModConnPointPairs(wallModConn);
                var xyPolyOfWMC = [
                  ptpairs.pair1[0],
                  ptpairs.pair1[1],
                  ptpairs.pair2[1],
                  ptpairs.pair2[0],
                ];
                if (uMath.isPolygonClockwise(xyPolyOfWMC)) {
                  xyPolyOfWMC.reverse();
                }
                var polyOfWMC = XYtoNumPoly(xyPolyOfWMC);
                innerDoorArea += d3.polygonArea(polyOfWMC);
                if (e.data.debug) {
                  innerDiff = uMath.polygonClipping.difference(innerDiff, [polyOfWMC]);
                }
              }
              catch (error) {
                console.debug(error);
                console.debug("Caught error while trying to calc inner door");
              }
            });

            if (e.data.debug) {
              PlannerGlobals.svg.selectAll('.innerDiffPrevPoly').remove();
              innerDiff.forEach(function (poly) {
                PlannerGlobals.container.insert('polygon', '#hullTestGL')
                  .attr('points', poly.map(function (pt) { return pt.join(" ") }).join(" "))
                  .attr('style', "fill: green; fill-opacity: 0.8;")
                  .attr('class', 'innerDiffPrevPoly');
              });
            }

            PlannerGlobals.lastCalculatedOuterWall = {
              outerWallArea: +((outerWallArea - hullArea - windowDoorArea) * PlannerGlobals.LENGTHOF1PX ** 2 / 10000).toFixed(2), //m2
              outerWallPerimeter: +(outerWallPerimeter * PlannerGlobals.LENGTHOF1PX / 100).toFixed(2), //m
              innerWallArea: +((hullArea - roomAllArea - innerDoorArea) * PlannerGlobals.LENGTHOF1PX ** 2 / 10000).toFixed(2) //m2
            };

            if (e.data.debug) {
              toastInfo(`
                        <b>DEBUG</b><br>
                        Outer wall's area (orange): ${PlannerGlobals.lastCalculatedOuterWall.outerWallArea}m<sup>2</sup><br>
                        Outer wall's perimeter (facing outside): ${PlannerGlobals.lastCalculatedOuterWall.outerWallPerimeter}m<br>
                        Inner walls' area (green): ${PlannerGlobals.lastCalculatedOuterWall.innerWallArea}m<sup>2</sup><br>
                        `);
              console.log(`
                        Outer wall's area (orange): ${PlannerGlobals.lastCalculatedOuterWall.outerWallArea}m2
                        Outer wall's perimeter (facing outside): ${PlannerGlobals.lastCalculatedOuterWall.outerWallPerimeter}m
                        Inner walls' area (green): ${PlannerGlobals.lastCalculatedOuterWall.innerWallArea}m2
                        `);
            }

          }
          if (PlannerGlobals.calcOuterPromise) {
            PlannerGlobals.calcOuterPromise.resolve();
          }
        }
        else if (e.data && e.data.floorId == PlannerGlobals.plannerFloorId) {
          PlannerGlobals.lastCalculatedOuterWall = {};
        }
      }
      catch (err) {
        console.debug(err);
      }
    }
  }
  if (debug) {
    performance.mark('calcStart');
  }
  PlannerGlobals.OUTERWALL_WORKER.postMessage({
    rooms: PlannerGlobals.rooms,
    concavity,
    wallGranularity,
    outerBorder: PlannerGlobals.outerBorder,
    debug,
    floorId: PlannerGlobals.plannerFloorId
  });
}